import { DefaultSidebar } from "@excalidraw/excalidraw";

import "./AppSidebar.scss";

export const AppSidebar = () => {
  return <DefaultSidebar />;
};
